export const normalizeCompanyData = (companyData) => {
  if (!companyData) {
    return [{
      cnpj: '',
      name: '',
      fantasyname: '',
      phone: '',
      address: '',
      admin: {
        username: '',
        email: '',
      },
      cnae_list: [],
      language: 'pt-BR',
      newField: true
    }];
  }

  if (Array.isArray(companyData?.companies)) {
    const uniqueCompanies = companyData.companies.reduce((acc, company) => {
      const existingCompany = acc.find(c => c.c_id_company === company.c_id_company);
      if (!existingCompany) {
        acc.push(company);
      }
      return acc;
    }, []);

    return uniqueCompanies.map(company => ({
      name: company.c_name || '',
      cnpj: company.c_cnpj || '',
      phone: company.c_phone || '',
      address: company.c_address || '',
      id_company: company.c_id_company,
      fantasyname: company.fantasyname || '',
      cnae_list: company.cnae_list || '',
      language: company.c_language || company.language || 'pt-BR',
      admin: company.admin?.email || company.admin?.username
        ? company.admin
        : { email: '', username: '' },
      newField: false,
      previousAdmin: !!(company.admin?.email || company.admin?.username)
    }));
  }

  return [{
    name: companyData.c_name || '',
    cnpj: companyData.c_cnpj || '',
    phone: companyData.c_phone || '',
    address: companyData.c_address || '',
    id_company: companyData.c_id_company,
    fantasyname: companyData.fantasyname || '',
    cnae_list: companyData.cnae_list || '',
    language: companyData.c_language || companyData.language || 'pt-BR',
    admin: companyData.admin?.email || companyData.admin?.username
      ? companyData.admin
      : { email: '', username: '' },
    newField: false,
    previousAdmin: !!(companyData.admin?.email || companyData.admin?.username)
  }];
};